import TechShipPortalAddModel from './techshipportaladdmodel-dialog-screen.vue';

export default {

    data: function () {
        return {
            loading: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID,
            model: {},
            channelSettings: {
                ApplicationId: 0,
                DomainSuffix: null
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',

                },
                {
                    name: 'Name',
                    label: 'Name',
                    align: 'left',
                    field: row => row.Name,
                    sortable: true,
                    style: '',

                },
                {
                    name: 'Domain',
                    label: 'Domain',
                    align: 'left',
                    field: row => row.Domain,
                    sortable: false,
                    style: '',

                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },

            ],
            columnsVisible: ['Name', 'Domain', 'Actions'],
            dataSource: [],

            filter: null,
            advancedFilter: null,
            selected: [],
            page: 1,
            pageSize: 50,
            hasMoreRows: true,
            pagination: {
                sortBy: 'Name',
                descending: true,
                rowsNumber: 0 // Need for 'QTable Request' event
            },
        }
    },

    methods: {
        onScroll({ to, ref }) {
            if (this.channelSettings.ApplicationId > 0 &&
                this.loading !== true &&
                this.hasMoreRows &&
                to === this.dataSource.length - 1) {
                this.loading = true;
                this.page++;

                this.onLoadListDataSource({
                    page: this.page,
                    pageSize: this.pageSize,
                    filter: this.filter,
                    advancedFilter: this.advancedFilter,
                    sortBy: this.pagination.sortBy,
                    descending: this.pagination.descending,
                    resetDataSource: false
                });
            }
        },

        onRequest(props) {
            this.loading = true;
            this.page = 1;

            this.onLoadListDataSource({
                page: this.page,
                pageSize: this.pageSize,
                filter: props.filter,
                advancedFilter: this.advancedFilter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
                resetDataSource: true
            });
        },

        onClearFilterActionClick() {
            this.filter = null;
            this.advancedFilter = null;
            this.page = 1;
            this.refreshScreen();
        },

        refreshScreen() {
            if (this.channelSettings.ApplicationId > 0) {
                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.dataSource = [];
            }
        },

        onCreateActionClick() {
            this.$q.dialog({
                component: TechShipPortalAddModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: {
                    ApplicationId: this.channelSettings.ApplicationId,
                    DomainSuffix: this.channelSettings.DomainSuffix
                },
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            });
        },

        onOpenPortalActionClick(rowKey, rowIndex, row) {
            this.onTechShipPortalsOpenServerActionDataSource({
                id: rowKey,
                dialogData: null,
                dialogFiles: null

            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    AdvancedFilter: params.advancedFilter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/techship_portals/byApplication/' + this.channelSettings.ApplicationId, requestBody);
                let listViewDataSource = response.body;

                if (listViewDataSource.Rows.length > fetchCount) {
                    this.hasMoreRows = true;
                    listViewDataSource.Rows.pop();
                } else {
                    this.hasMoreRows = false;
                }

                if (params.resetDataSource) {
                    this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                } else {
                    this.dataSource.push(...listViewDataSource.Rows);
                }

                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    this.dataSource = response.body.Rows;
                }

                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;
                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onTechShipPortalsOpenServerActionDataSource(params) {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                // Request from grid row.
                let url = this.$prepareServerUrl('/api/ui/techship_portals/open/' + this.channelSettings.ApplicationId + '/{id}', params.id, params.params, null);
                let response = await this.$http.post(url, params.dialogData, {});

                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.$q.loading.hide();
            }
        },

        onLoadFieldDataSources() {

        },
    },

    computed: {
        screenTitle: function () {
            return 'techSHIP Portals';
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}